import React, {useEffect, useState} from "react";
import AutoFormCard from "../../../components/common/AutoFormCard";
import {useNavigate, useSearchParams} from "react-router-dom";
import {ApiService} from "../../../services/ApiService";
import {message} from "antd";
import {FileUploadUtils} from "../../../utils/FileUploadUtils";
import {FormUtils} from "../../../utils/FormUtils";

const FORM = [
    {
        name: "场所名称",
        key: "name",
        type: "input",
    },
    {
        name: "宗教类型",
        key: "religionId",
        type: "select",
    },
    {
        name: "场所编号",
        key: "number",
        type: "input",
    },
    {
        name: "场所负责人",
        key: "officer",
        type: "input",
    },
    {
        name: "场所地址",
        key: "address",
        type: "text",
        maxLength: 100,
    },
    {
        name: "场所介绍",
        key: "comment",
        type: "text",
        maxLength: 1000
    },
    {
        name: "场所坐标",
        key: "coordinates",
        type: "input"
    },
    {
        name: "场所图片",
        key: "imageUrl",
        type: "img",
        maxCount: 1
    }
]

const ReligionVenueEditPage = () => {
    const [searchParams] = useSearchParams()
    const navigator = useNavigate()

    const guid = searchParams.get("guid")

    const [initFormData, setInitFormData] = useState({})
    const [religions, setReligions] = useState([])
    const [initFiles, setInitFiles] = useState({})

    let changedForms = {}
    let changedFiles = {}

    useEffect(() => {
        if (guid) {
            ApiService.admin.religion.venue.get(guid)
                .onSuccess(data => {
                    const initFormData = data
                    const initFiles = {}
                    if (data.imageUrl) {
                        initFiles["imageUrl"] = [FileUploadUtils.toInitFileMap(0, data.imageUrl)]
                    }

                    setInitFormData(initFormData)
                    setInitFiles(initFiles)
                })
        }

        ApiService.constants.religion()
            .onSuccess(setReligions)
    }, [guid]);

    const handleFormChange = (change) => {
        changedForms = {
            ...changedForms,
            ...change
        }
    }

    const handleFileChange = (change) => {
        changedFiles = {
            ...changedFiles,
            ...change
        }
    }

    const createOrUpdate = (form) => {
        if (guid) {
            return ApiService.admin.religion.venue.update(form)
        } else {
            return ApiService.admin.religion.venue.create(form)
        }
    }

    const handleFormSubmit = (event) => {
        try {
            const form = FormUtils.setupSubmitForm(changedForms, changedFiles, true, false, {guid: guid})
            createOrUpdate(form)
                .onSuccess(() => {
                    message.success("数据已保存")
                    navigator(-1)
                })
        } catch (e) {
            message.error(e.message)
            return false
        }
    }

    return (
        <>
            <AutoFormCard
                title={"港澳台人员信息编辑"}
                extra={<a href="http://api.map.baidu.com/lbsapi/getpoint/" target="_blank">[拾取坐标系统]</a>}
                formStruct={FORM}
                initValues={initFormData}
                initFiles={initFiles}
                selectOptions={{
                    religionId: religions
                }}
                loading={false}
                onClickCancel={e => {
                    navigator(-1)
                }}
                onClickSubmit={handleFormSubmit}
                onFormChange={handleFormChange}
                onFileChange={handleFileChange}
            />
        </>
    )
}

export default ReligionVenueEditPage